import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";

require('./price-plan-tree-node.scss');
@Component({
  standalone: false,
  selector: 'app-price-plan-tree-node',
  templateUrl: './price-plan-tree-node.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricePlanTreeNodeComponent implements OnChanges {

  @Input() pricePlan: any;
  @Input() selectedPricePlanId: string;
  @Input() expandedNodesMap: any;
  @Output() selectPricePlanEvent = new EventEmitter<string>();
  @Output() viewPricePlanDrillDownEvent = new EventEmitter<string>();
  @Output() toggleExpandEvent = new EventEmitter<{ ixExpanded: boolean, pricePlanId: string }>();


  public isExpanded: boolean = false;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.expandedNodesMap && this.expandedNodesMap) {
      this.isExpanded = !!this.expandedNodesMap[this.pricePlan.id];
    }
  }

  onToggleExpand(event) {
    event.stopPropagation();
    this.toggleExpandEvent.emit({ixExpanded: !this.isExpanded, pricePlanId: this.pricePlan.id});
  }

  onToggleChildExpand(event) {
    this.toggleExpandEvent.emit({ixExpanded: event.ixExpanded, pricePlanId: event.pricePlanId});
  }

  onSelectPricePlan(event) {
    event.stopPropagation();
    this.selectPricePlanEvent.emit(this.pricePlan.id);
  }

  onSelectChildPricePlan(event: string) {
    this.selectPricePlanEvent.emit(event);
  }

  onViewChildPricePlanDrillDown(event: string) {
    this.viewPricePlanDrillDownEvent.emit(event);
  }

  onViewPricePlanDrillDown() {
    this.viewPricePlanDrillDownEvent.emit(this.pricePlan.id);
  }

}
